<template>
  <div class="table-item">
    <div class="table-item-header">
      <TableHeader
        :data="head"
        :column="column"
      />
      <div>
        <slot name="btns" />
        <span class="show-icon" :class="{ 'is-show': show }" @click="show = !show">
          {{ show ? $t('bidmanagementpur.biddingmonitoring.notShow') : $t('bidmanagementpur.biddingmonitoring.doShow') }}
          <i class="iconfont icon-zhankai" />
        </span>
      </div>
    </div>
    <el-collapse-transition>
      <div v-show="show">
        <el-scrollbar>
          <StripeTable
            :[tableProp]="table"
            :hide-head="false"
            :list="body"
            style="padding: 0;"
          />
        </el-scrollbar>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
import TableHeader from '@/components/table/table-header/table-header'
import StripeTable from '@/components/table/stripe-table/stripe-table'
import Table from '@utils/table'
import CountCell from './count-cell'
import PreviewFile from '@/components/select/upload-select/preview-file'
const supplierColumn = [
  { prop: 'index', component: CountCell },
  { prop: 'supOfficeName', label: 'bidmanagementpur.biddingmonitoring.supOfficeName' },
  { prop: 'quoteTime', label: 'bidmanagementpur.biddingmonitoring.quoteTime' },
  { prop: 'sumAmount', label: 'bidmanagementpur.biddingmonitoring.sumAmount' }
]

const itemColumn = [
  { prop: 'index', component: CountCell },
  { prop: 'name', label: 'bidmanagementpur.biddingmonitoring.name' },
  { prop: 'number', label: 'bidmanagementpur.biddingmonitoring.number' },
  { prop: 'model', label: 'bidmanagementpur.biddingmonitoring.model' },
  { prop: 'qty', label: 'bidmanagementpur.biddingmonitoring.qty' }
]

function parseFile(files = []) {
  return files.map(item => {
    return {
      name: item.fileName,
      url: '/srmFile/getFile',
      baseURL: process.env.VUE_APP_BASE_API,
      fileId: item.fileId,
      data: { fileId: `${item.fileId}` }
    }
  })
}

const table = new Table('bidmanagementpur.biddingmonitoring')
  .sortable(false)
  .edit(true)
  .type('index')
  .add('goodsType')
  .add('number')
  .add('name')
  .add('expirationDate')
  .add('model')
  .add('category')
  .add('technologyName')
  .add('unit')
  .add('currencyNo')
  .add('qty')
  .add('fixedPrice')
  .add('giveUpSign')
  .add('goodsPrice')
  .add('taxRate')
  .add('taxIncludedAmount')
  .add('remarks')
  .add('purchaseStandard')
  .add('expectedDeliveryDate')
  .add('goodsFileList').editor({ component: PreviewFile, parse: parseFile })

export default {
  components: {
    TableHeader,
    StripeTable
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    },
    searchType: {
      type: String,
      default: ''
    }
  },
  computed: {
    show: {
      get() {
        return this.data.show
      },
      set(val) {
        this.data.show = val
      }
    },
    head() {
      return this.data.head ? { ...this.data.head, index: this.index, searchType: this.searchType } : {}
    },
    body() {
      return this.data.body || []
    },
    column() {
      if (this.searchType === 'item') {
        return itemColumn
      }
      return supplierColumn
    },
    tableProp() {
      return '$table'
    },
    table() {
      return table
    }
  }
}
</script>

<style lang="scss" scoped>
.table-item {
  padding: 10px 12px;
  background: #fff;
  margin-bottom: 12px;
  &-header {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .show-icon {
    cursor: pointer;
    color: #999;
    display: inline-flex;
    align-items: center;
    &.is-show {
      i {
        transform: rotate(180deg);
      }
    }
    i {
      vertical-align: 1px;
      transition: all .3s;
    }
  }
}
</style>
